
import { Component } from '@angular/core';

@Component({
  selector: 'bmi-table-skeleton-item',
  standalone: true,
  imports: [],
  templateUrl: './bmi-table-skeleton-item.component.html',
  styleUrl: './bmi-table-skeleton-item.component.scss',
})
export class BmiTableSkeletonComponent {
}
